import { gql } from "graphql-request";

export const CATEGORIES_GET_ALL_CATEGORIES = gql`
    query categoriesGetAllCategoriesQuery($domainId: Int) {
        domain(id: $domainId) {
            categories(
                limit: 100
                orderBy: createdAt
                isPublished: true
                isDeleted: false
            ) {
                id
                parentId
                title
                name
                slug
                label
                url(isActive: true, isDeleted: false) {
                    isMain
                    main {
                        url
                    }
                    url
                }
                translations {
                    key
                    value
                    language
                }
                categoryChilds {
                    id
                    slug
                    parentId
                    title
                    name
                    url {
                        isMain
                        url
                        main {
                            url
                        }
                    }
                }
            }
        }
    }
`;
